module.exports = __webpack_public_path__ + "static/media/logo.daf547ae.png";